// extracted by mini-css-extract-plugin
module.exports = {"container":"institution-item_container__mHBpO","containerLink":"institution-item_containerLink__pYlBX","logo":"institution-item_logo__4gMkf","text":"institution-item_text__1plvH"};